// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passcodeKeypad-module_keypad__EcZvp {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 320px;
    max-width: 100%;
    margin-top: 68px;
}

.passcodeKeypad-module_row__YdtJN {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.passcodeKeypad-module_placeholder__klMDJ {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Inputs/passcodeKeypad.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".keypad {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    width: 320px;\n    max-width: 100%;\n    margin-top: 68px;\n}\n\n.row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n}\n\n.placeholder {\n    width: 56px;\n    height: 56px;\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keypad": `passcodeKeypad-module_keypad__EcZvp`,
	"row": `passcodeKeypad-module_row__YdtJN`,
	"placeholder": `passcodeKeypad-module_placeholder__klMDJ`
};
export default ___CSS_LOADER_EXPORT___;
